
// -----------------video slider----------------//

var swiper = new Swiper('.video-box-slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: true,
  // slideToClickedSlide: true,
  a11y: false,
  shortSwipes: true,
 navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  breakpoints: {
    749: {
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});


  
// -----------------video----------------//

document.addEventListener('DOMContentLoaded', function () {
  const videoImages = document.querySelectorAll('.video-box-slider .video-image');

  videoImages.forEach(videoImage => {
    const video = videoImage.querySelector('video');

    if (video) {
      videoImage.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          videoImage.classList.add('playing');
        } else {
          video.pause();
          videoImage.classList.remove('playing');
        }
      });
    }
  });
});



// -------------------------Faq start-----------------------//

  //this is the button
  var acc = document.getElementsByClassName("course-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
  	//when one of the buttons are clicked run this function
    acc[i].onclick = function() {
  	//variables
  	var panel = this.nextElementSibling;
  	var coursePanel = document.getElementsByClassName("course-panel");
  	var courseAccordion = document.getElementsByClassName("course-accordion");
  	var courseAccordionActive = document.getElementsByClassName("course-accordion active");

  	if (panel.style.maxHeight){
  		panel.style.maxHeight = null;
  		this.classList.remove("active");
  	} else {
  		for (var ii = 0; ii < courseAccordionActive.length; ii++) {
  			courseAccordionActive[ii].classList.remove("active");
  		}
  		for (var iii = 0; iii < coursePanel.length; iii++) {
  		  this.classList.remove("active");
  		  coursePanel[iii].style.maxHeight = null;
  		}
  	  panel.style.maxHeight = panel.scrollHeight + "px";
  	  this.classList.add("active");
  	}
    }
       acc[0].nextElementSibling.style.maxHeight = acc[0].nextElementSibling.scrollHeight + "px";
  }




// -----------------------custom-featured-poduct start tab-------------------------//


  
//  // Add this JS to your theme's script file or within a <script> tag in your Liquid file

document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.accordion-button');
  
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      buttons.forEach(btn => {
        btn.classList.remove('active');
      });
      this.classList.add('active');
      const content = this.nextElementSibling;
      
      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        document.querySelectorAll('.accordion-content').forEach(item => item.style.display = 'none');
        content.style.display = 'block';
      }
    });
  });
});





// -----------------------------

document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('.var-click-js');
    
    elements.forEach(function (element) {
        element.addEventListener('click', function () {
            // Remove the class from all siblings
            elements.forEach(function (sibling) {
                sibling.classList.remove('pouches_text_item_main');
            });
            
            // Add the class to the clicked element
            this.classList.add('pouches_text_item_main');
        });
    });
});







var swiper = new Swiper('.custom_slider_block-desktop', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
   navigation: {
      nextEl: '.custom_slider_block-desktop .swiper-button-next',
      prevEl: '.custom_slider_block-desktop .swiper-button-prev',
    },
});
var swiper = new Swiper('.custom_slider_block-mobile', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
   navigation: {
      nextEl: '.custom_slider_block-mobile .swiper-button-next',
      prevEl: '.custom_slider_block-mobile .swiper-button-prev',
    },
});


// ---------feel--section------video slider    2----------------//





var swiper = new Swiper('.video-box-slider1', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: true,
  // slideToClickedSlide: true,
  a11y: false,
  shortSwipes: true,
  breakpoints: {
    749: {
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});






  
// -----------feel section------video----------------//

document.addEventListener('DOMContentLoaded', function () {
  const videoImages = document.querySelectorAll('.video-box-slider1 .video-image1');

  videoImages.forEach(videoImage => {
    const video = videoImage.querySelector('video');
    const videoIcone = videoImage.querySelector('.see-play-button');

    if (video) {
      videoImage.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          videoImage.classList.add('playing');
            videoIcone.setAttribute('hidden', true);
        } else {
          video.pause();
          videoImage.classList.remove('playing');
          if(videoIcone.hasAttribute('hidden')){  
            videoIcone.removeAttribute('hidden');
          }
        }
      });
    }
  });
});




                              


 
